import React from 'react';
import { StyledGridContainer, StyledGridItem } from '../Shared/Styled';
import '../../utils/scrollIntoViewIfNeeded';
import { ThemeString, useThemeContext } from '../../context';
import { defaultFont, separatorColor } from '../../styles/SharedStyles';
import { SelectItem } from '../../types';
import defaultImage from '../../assets/Default-Thumbnail-Image-Small.png';

export interface SelectGridProps {
  selected?: string;
  items: SelectItem[];
  selectedProperty?: string;
}

export function SelectGrid({
  selected,
  items,
  selectedProperty,
}: SelectGridProps): JSX.Element {
  const selectedProp = selectedProperty || 'text';
  const theme = useThemeContext();

  return (
    <StyledGridContainer>
      <Grid
        items={items}
        theme={theme}
        selected={selected}
        selectedProp={selectedProp}
      />
    </StyledGridContainer>
  );
}

interface LabelProps {
  text?: string;
  theme: any;
}

interface GridProps {
  items: SelectItem[];
  theme: ThemeString;
  selected?: string;
  selectedProp: string;
}

function Grid({
  items,
  theme,
  selected,
  selectedProp,
}: GridProps): JSX.Element {
  return (
    <StyledGrid>
      {items.map((item, index) => {
        return (
          <GridItem
            key={index}
            index={index}
            item={item}
            theme={theme}
            selected={selected === item[selectedProp]}
          />
        );
      })}
    </StyledGrid>
  );
}

interface StyledGridProps {
  children: any;
}

function StyledGrid({ children }: StyledGridProps): JSX.Element {
  const theme = useThemeContext();
  return (
    <ul
      style={{
        listStyleType: 'none',
        paddingLeft: '0',
        margin: '0',
        position: 'relative',
        ...defaultFont,
        flexGrow: 1,
        overflowY: 'auto',
        border: '1px solid',
        borderColor: separatorColor(theme),
        borderTop: '0',
        boxSizing: 'border-box',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
      }}
    >
      {children}
    </ul>
  );
}

interface GridItemProps {
  item: SelectItem;
  theme: ThemeString;
  selected: boolean;
  index: number;
}

function GridItem({
  item,
  theme,
  selected,
  index,
}: GridItemProps): JSX.Element {
  return (
    <StyledGridItem
      item={item}
      onClick={item.onClick}
      index={index}
      selected={selected}
      ref={el => selected && el && el.scrollIntoViewIfNeeded()}
      themeStr={theme}
      hasBorder={!!item.additionalText}
      data-testid={`select_list_item_${index}`}
    >
      <div title={item.title}>
        <img
          max-width='150px'
          max-height='100px'
          height='100px'
          src={item.icon ? item.icon : defaultImage}
        />
        <p>{item.text}</p>
      </div>
    </StyledGridItem>
  );
}
